import { Col, Row } from '@design-system/components/grid/grid';
import { FormRowHeader, StyleSchema } from './common/FormRows';
import { useRowStyle } from './common/useRowStyle';
import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { IconButton } from '@design-system/components/button/iconButton';
import { Button } from '@design-system/components/button/button';
import { ActionableItemList } from './common/ActionableItemList';
import {
  CollapsibleWorkoutHeader,
  HeaderContent,
} from './common/WorkoutHeader';

import * as styles from './TabataExercise.css';
import { ExerciseDetails, ExerciseMedia } from './common/ExerciseDetails';
import { AMRAPSwitch } from './common/AMRAPSwitch';
import { useSubExerciseVM } from '../../view-model/subexercise.viewmodel';
import { WorkoutItemMenu } from '@client/new/pages/workout/components/WorkoutItemMenu';
import { workoutVM } from '@client/new/pages/workout/WorkoutEdit';
import { Errors } from '@client/new/pages/promotions/view/components/Errors';
import { SetRenderer } from './common/SetRenderer';
import { TabataExerciseSetDTO } from '../../model/workout.domain';

export const styleSchema: Array<StyleSchema> = [
  {
    width: 40,
    title: 'Set',
  },
  { width: 87, title: 'Time' },
  { title: 'Reps' },
  { width: 87, title: 'Rest' },
  { width: 33, title: '' },
];

export const TabataExercise = ({ id }: { id: string }) => {
  const workout = workoutVM.useValue();
  const ex = useSubExerciseVM(workout, id);

  //todo: remove
  const style = useRowStyle({
    styleSchema,
  });

  return (
    <CollapsibleWorkoutHeader
      className={styles.wrapper}
      Header={<HeaderContent title={ex.name || 'Tabata'} />}
      Action={
        <WorkoutItemMenu
          items={ex.menuItems}
          isCircuit
          // readonly={readonly}
        />
      }
      defaultOpen={true}
      variant="secondary"
    >
      <Row className={styles.errorsWrapper}>
        <Errors data={ex.errors} />
      </Row>
      <Row className={styles.content}>
        <ExerciseMedia exercise={ex} />
        <Col style={{ gridArea: 'description' }}>
          <ExerciseDetails exercise={ex} />
        </Col>
        <Col style={{ gridArea: 'set' }}>
          <FormRowHeader styleSchema={styleSchema} style={style} />
          <ActionableItemList
            data={ex.fieldsWithSets}
            rowStyle={style}
            render={(d, id2) => (
              <SetRenderer
                index={id2}
                register={ex.register}
                data={d as TabataExerciseSetDTO}
              />
            )}
            action={(i) => (
              <IconButton
                icon={faClose}
                variant="text"
                color="neutral"
                onClick={() => ex.dispatch('RemoveSet', { setIndex: i })}
              />
            )}
            minimumItems={1}
          />

          <Col style={{ alignItems: 'flex-start', marginTop: 16 }} gap="xl">
            <Button
              variant="filled"
              color="primaryTonal"
              onClick={() => ex.dispatch('AddSet')}
            >
              Add set
            </Button>
            <AMRAPSwitch
              onChange={ex.lazyDispatch('SetAMRAP')}
              value={ex.isAMRAP}
            />
          </Col>
        </Col>
      </Row>
    </CollapsibleWorkoutHeader>
  );
};
